<template>
  <DBox
    :id="'cmp-booking-booking-booking_sidewindow-local-details'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="`${$t('add_new_local_details')}`"
    :topRightMenu="[
      {
        text: $t('cant_edit_question'),
        icon: iconSrc,
        value: 'lock',
      },
    ]"
    @add_click="addLocalDetailsClick"
    @menuClick="changeLDCFlag"
  >
    <!-- :addInfo="!local_details_confirmed_flag"
    :addInfoLabel="'Unlock To Add New  Row'" -->

    <NTable
      v-if="
        booking.calendar_date_locals && booking.calendar_date_locals.length > 0
      "
      class="artist-list dbox1"
      :id="'booking-booking-booking_sidewindow-artists'"
      :headers="relationHeader"
      :items="booking.calendar_date_locals"
      :config="tableConfig"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td
            @click.stop="(e) => onLocalDetailsClicked(item)"
            v-bind="tdcon('type')"
          >
            <span class="ut-link ut-text-accent5">{{
              item["local_details_type_name"]
            }}</span>
          </td>
          <td v-bind="tdcon('name')">
            <span>{{ item["name"] }}</span>
          </td>
          <td v-bind="tdcon('contact')">
            <div class="ut-flex">
              <div class="dt-icon-container">
                <img
                  :title="item['phone']"
                  :class="{ inactive: !item['phone'] }"
                  src="static/icons/phone.svg"
                  class="dt-icon v5 s1"
                  alt="Call"
                  @click="(e) => callLocalDetails(item, e)"
                />
              </div>
              <div class="dt-icon-container">
                <img
                  :title="item['email']"
                  :class="{ inactive: !item['email'] }"
                  src="static/icons/email/email-grey.svg"
                  class="dt-icon v5 s1"
                  alt="Email"
                  @click="(e) => mailLocalDetails(item, e)"
                />
              </div>
              <div class="dt-icon-container">
                <img
                  :title="item['url']"
                  :class="{ inactive: !item['url'] }"
                  src="static/icons/web.svg"
                  class="dt-icon v5 s1"
                  alt="Web"
                  @click="(e) => visitLocalDetails(item, e)"
                />
              </div>
            </div>
          </td>
          <td v-bind="tdcon('related_contact')" style="border-right: none;">
            <span :title="mapIdsToNames(item['contact_person_realted_id'])">{{
              mapIdsToNames(item["contact_person_realted_id"])
            }}</span>
          </td>

          <td
            v-bind="tdcon('lock')"
            @click.stop="(e) => $emit('lockQuestion', { name: 'toggle_json_item', value: `local_details_${item.local_detail_id}` })"
          >
            <img
              :src="lockJson[`local_details_${item.local_detail_id}`] == 'lock' ? 'static/icons/booking/lock-closed.svg' : 'static/icons/booking/lock-open.svg'"
              class="dt-icon v5 s1"
            />
          </td>
          <td
            v-bind="tdcon('options')"
            @click.stop="(e) => onLocalDetailsRemove(item)"
          >
            <img
              src="static/icons/delete.svg"
              class="dt-icon v5 s1"
            />
          </td>
        </tr>
      </template>
    </NTable>
    <div class="import-button" v-else>
      <div class="button-container">
        <button class="dt-button v5 s8" @click="usePreviousDetails">
          {{$t('use_previous_details_string')}}
        </button>
      </div>
    </div>
    <template v-if="localDetailsModalContainer">
      <v-dialog v-model="localDetailsModal" persistent :width="modalWidth">
        <LocalDetailsForm
          :contactRelations="booking.contact_relations"
          :calendarDateId="booking.cdate.calendar_date_id"
          :relationTypes="booking.relation_types"
          @cancelled="onLocalDetailsCancelled"
          @submit_local_details="onLocalDetailsSubmit"
          @show_column="showColumn"
        />
      </v-dialog>
    </template>

    <template v-if="loadPromoterDefaultModalContainer">
      <v-dialog
        v-model="loadPromoterDefaultModal"
        persistent
        :width="MODAL_DEFAULT_MEDIUM"
      >
        <PromoterDefaultNew
          :calendar_date_id="booking.cdate.calendar_date_id"
          @cancelled="onLoadPromoterDefaultCancelled"
          @loadPromoterDefault="onLoadPromoterDefault"
        />
      </v-dialog>
    </template>
    <template slot="bottomRight">
      <div class="ut-flex ut-fh ut-mr-10px">
        <div class="local-details-confirmed">
          <div class="label"> {{$t('local_details_confirmed')}} </div>
          <div class="checkbox">
            <div class="dt-checkbox v2 s1" v-if="booking.cdate">
              <input
                type="checkbox"
                :checked="local_details_confirmed_flag"
                @click.stop="(e) => onLocalDetailsConfirmedFlagChange(e)"
              />
              <div class="checkmark"></div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </DBox>
</template>

<script>
import * as R from "ramda";
import * as querystring from "querystring";

import PromoterDefaultNew from "./promoter-default-new";
import LocalDetailsForm from "./local-details-form";
import { BookingService } from "../../services/booking-service";
import {
  getFormsArray,
  localDetailsCustomData,
  pickLocalformCustom,
  getPromoterDefaultDetails,
} from "../../models/local-details.model";
import {
  createModalMixin,
  openModalRoute,
  closeModalRoute,
  MODAL_DEFAULT_MEDIUM,
} from "../../../../dt-plugins/modal/modal.mixin";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import { openWindow, sendMail } from "../../../../utility";
import { defaultTo, propOr } from "ramda";
import NTable from "@/plugins/datatable/datatable";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
export default {
  components: {
    NTable,
    PromoterDefaultNew,
    LocalDetailsForm,
  },
  props: ["booking", "lockJson"],
  data: function () {
    return {
      MODAL_DEFAULT_MEDIUM: MODAL_DEFAULT_MEDIUM,
      promoterDefaultNewFlag: false,
      localDetailsFormFlag: false,
      localdetailsFormMode: "add",
      localDetailsMore: null,
      canEdit: true,
      modalWidth: 762,
      //local_details_confirmed_flag: true,

      promoterDefault: {},
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
        footer: false,
      }),
    };
  },
  mounted: async function () {},
  mixins: [
    createModalMixin("localDetails"),
    createModalMixin("loadPromoterDefault"),
  ],
  computed: {
    relationHeader: function () {
      return [
        createTableHeader("type", {}),
        createTableHeader("name", ),
        createTableHeader("contact", { mw: 90 }),
        createTableHeader("related_contact", {f: 1.8}),
        createTableHeader("lock", { mw: 30, text: false  }),
        createTableHeader("options", { mw: 30, text: false }),
      ];
    },
    iconSrc: function () {
      return  this.isLocked
        ? "lock-closed.svg"
        : "lock-open.svg";
    },
    isLocked: function () {
      const lockedCount = this.booking.calendar_date_locals.filter(row => ( this.lockJson[`local_details_${row.local_detail_id}`] === 'lock' )).length;
      return  this.booking.calendar_date_locals.length != 0 && (lockedCount == this.booking.calendar_date_locals.length)
        ? true
        : false;
    },
    contactPersons: function () {
      return this.booking.contact_relations
        .map((e) => e.contact_name)
        .join(", ");
    },
    local_details_confirmed_flag: function () {
      return (
        this.booking.cdate.local_details_confirmed_flag == 1 ||
        this.booking.cdate.local_details_confirmed_flag == "1"
      );
    },
  },
  methods: {
    changeLDCFlag: function (value) {
      console.log("value", this.local_details_confirmed_flag ? "0" : "1");
      //this.local_details_confirmed_flag = !this.local_details_confirmed_flag;

      this.$emit("lockQuestion", {
        name: "local_details_confirmed_flag",
        value: this.isLocked ? "0" : "1",
      });
    },
    onLocalDetailsRemove: async function (localDetails) {
      const confirmationResult = await confirmDelete(
        "Local Detail",
        localDetails.name
      );
      if (confirmationResult === "OK") {
        this.$emit("deleted", localDetails);
      }
      // ConfirmationService.create({
      //   subject: "Do you really want to delete this Local Detail?",
      //   model: true,
      //   width: 400,
      //   results: [
      //     createConfirmResult({
      //       value: "No",
      //     }),
      //     createConfirmResult({
      //       value: "Yes",
      //       classes: ["v1"],
      //     }),
      //   ],
      //   completed: (res) => {
      //     switch (res) {
      //       case "Yes": {
      //         this.$emit("deleted", localDetails);
      //         break;
      //       }
      //       default: {
      //       }
      //     }
      //   },
      // });
    },
    onLocalHotelMailClick: function (localDetails) {
      const { email } = localDetails;
      // console.log("onLocalHotelMailClick");
      // This is the previous behavior --
      // The Body used to be fetched from an API call and then populated --

      // BookingService.findHotelMail(this.booking.cdate.calendar_date_id, localDetails.local_detail_id, localDetails.name, localDetails.address1, localDetails.city, localDetails.postalcode, localDetails.country).then((res) => {
      //   sendMail({
      //     body: res.data.new_shorten_url,
      //     mails: [email]
      //   });
      // });

      sendMail({
        body: "",
        subject: "Book Hotel Link",
        mails: [email],
      });
    },
    createMailString: function (url, email) {
      return `mailto:${email}?${querystring.stringify({
        subject: "Book Hotel Link",
        body: url,
      })}`;
    },
    usePreviousDetails: function (event) {
      openModalRoute(this, "load_promoter_default");
    },
    onLoadPromoterDefault: function (calendarDateId) {
      this.$emit("save_promoter", {
        fromCalendarDateId: calendarDateId,
      });
      // this.promoterDefaultNewFlag = false;
      closeModalRoute(this);
    },
    onLoadPromoterDefaultCancelled: function (event) {
      this.promoterDefaultNewFlag = false;
      closeModalRoute(this);
    },
    addLocalDetailsClick: function (event) {
      // this.localdetailsFormMode = 'add';
      // this.localDetailsFormFlag = true;

      openModalRoute(this, "local_details", {
        mode: "add",
      });
    },
    onAddLocalDetailsCancelled: function () {
      // this.localDetailsFormFlag = false;
      closeModalRoute(this, {
        mode: undefined,
      });
    },
    onLocalDetailsSubmit: async function (payload) {
      if (payload.mode === "add") {
        this.$emit("added", {
          payload,
        });
        this.onLocalDetailsCancelled();
      } else if (payload.mode === "edit") {
        this.$emit("saved", {
          payload,
        });
        this.onLocalDetailsCancelled();
      }
    },
    showColumn: function (payload) {
      console.log("Show width ", payload);
      if (payload == false) {
        console.log("Show width ", payload);
        this.modalWidth = 762;
      } else {
        this.modalWidth = 1023;
      }
    },
    mapIdsToNames: function (idString = "") {
      // console.log(idString);
      // return 'DEMO';
      idString = defaultTo("", idString);
      const ids = defaultTo([], idString.split(","));
      return ids
        .map((id) =>
          propOr(
            "",
            "contact_name",
            this.booking.contact_relations.find((e) => e.contact_id == id)
          )
        )
        .filter((e) => e)
        .join(", ");
    },
    onLocalDetailsClicked: function (item) {
      console.log(item);
      // this.localdetailsFormMode = 'edit';
      // this.localDetailsFormFlag = true;

      openModalRoute(this, "local_details", {
        mode: "edit",
        local_detail_id: item.local_detail_id,
      });

      // BookingService.findLocalDetailsMore({
      //   calendarDateId: this.calendarDateId,
      //   localDetailsId: localDetails.local_detail_id
      // }).then(res => {
      //   console.log(res);
      //   console.log(getFormsArray(res.data, 'custom_data_id'));
      //   const localDetails = {
      //     forms: getFormsArray(res.data, 'custom_data_id'),
      //     formData: {
      //       ...res.data.local_details,
      //       ...localDetailsCustomData(res.data.local_details_custom)
      //     },
      //     selectedContactRelations: res.data.local_details_contacts
      //   }
      //   this.localDetailsMore = localDetails;
      // })
    },
    onLocalDetailsCancelled: function () {
      closeModalRoute(this, {
        mode: undefined,
        local_detail_id: undefined,
      });
    },

    callLocalDetails: function (item, e) {
      if (item["phone"]) {
        openWindow(`tel:${item["phone"]}`);
        e.stopPropagation();
      }
    },
    mailLocalDetails: function (item, e) {
      if (item["email"]) {
        // openWindow(`mailto:${localDetails["email"]}`);
        sendMail({
          mails: [item["email"]],
        });
        e.stopPropagation();
      }
    },
    visitLocalDetails: function (item, e) {
      if (item["url"]) {
        window.open(`http://${item["url"]}`, "_blank");
        e.stopPropagation();
      }
    },
    onLocalDetailsConfirmedFlagChange(event) {
      this.$emit("local_details_confirmed_flag_changed", event.target.checked);
    },
    //MARK: METHODS
  },
};
</script>

<style scoped lang="scss">
.dt-list-item {
  cursor: pointer;
  height: 30px;
  .dt-list-item--column {
    padding: 0px 8px;

    &:nth-child(1) {
      flex: 0.7;
    }
    &:nth-child(3) {
      flex: 0.5;
    }
    &:nth-child(4) {
      flex: 0.5;
    }
    &:nth-child(5) {
      flex: 2;
    }
    &:nth-child(6) {
      flex: 0.1;
    }

    &.local-details-type {
      padding-left: 10px;
      display: flex;
      .text {
        padding-top: 5px;
        flex: 1;
      }
      .mail-icon {
        flex: 1.7;
      }
    }

    &.contact-options {
      display: flex;

      // .dt-icon {
      //   flex: 1;
      // }

      // .confirm-checkbox {
      //   margin-top: 15px;
      //   margin-bottom: -20px;
      //   flex: 1;
      // }
    }
  }
}

.local-details-confirmed {
  .label {
    color: var(--text-secondary)
  }
}

.import-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 64px;

  .button-container {
    text-align: center;
  }
}
</style>
